import { createSlice } from '@reduxjs/toolkit';

let initialState = {
  investorsOnPage: 40
};

const admin = createSlice({
  name: 'adminReducer',
  initialState,
  reducers: {
    setInvestorsOnPage(state, action) {
      state.investorsOnPage = action.payload;
    }
  }
});

export const { setInvestorsOnPage } = admin.actions;

export default admin.reducer;
